export const peruIncaTrailProgram = {
  programKey: 'peru-machu-picchu-i-tradycje-andow',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Peru - Machu Picchu i tradycje Andów',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Peru:',
  stickySubtitle: 'Machu Picchu i tradycje Andów',

  pageUrl:
    'https://coolturystki.pl/wycieczki/peru-machu-picchu-i-tradycje-andow',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-peru-machu-picchu-mu9taapg.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-peru-machu-picchu-mu9taapg.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Peru'],
    continent: 'Ameryka Południowa',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Aktywnie'],
    catalogPublishedAt: '2026-09-22',
  },

  /* Termin o ID 21: 8 - 21 maja 2027. */
  tripIds: [21],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '21': {
      pilotId: 'iza',
      group: 'Dla kobiet',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa rozpoczyna podróż na Lotnisku Chopina w Warszawie (WAW) i leci do Limy (LIM). Program obejmuje także przeloty wewnętrzne z Limy do Cusco oraz z Cusco do Limy, a wspólny powrót odbywa się z Limy do Warszawy.',
        },
        hotel: {
          title: 'Hotele 3★ na trasie',
          description:
            '12 noclegów w pokojach 2-osobowych w hotelach 3★ w Limie, Cusco, Ollantaytambo i Puno. W cenie są śniadania oraz 2 lunche.',
        },
      },
    },
  },
}
